import React, { useEffect, useState } from 'react';
import './Header.css';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);
  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      {/* Top Info Bar */}
      {/* <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <span className="info-item">
                <i className="fas fa-phone"></i>
                +91-8400621111
              </span>
              <span className="info-item">
                <i className="fas fa-envelope"></i>
                newabcmontessori63@gmail.com
              </span>
            </div>
            <div className="social-links">
              <a href="#facebook" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#twitter" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#instagram" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Navigation */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container">
          <a className="navbar-brand logo" href="#home">
            <div className="logo-wrapper">
              <span className="logo-icon"><img src="/images/logo.png" alt="" /></span>
              <span className="logo-text">New ABC Montessori</span>
            </div>
          </a>
          
          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav"
            aria-controls="navbarNav" 
            aria-expanded="false" 
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto nav-menu">
              <li className="nav-item">
                <a href="#home" className="nav-link active">
                  <i className="fas fa-home"></i>
                  <span>Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="#about" className="nav-link">
                  <i className="fas fa-heart"></i>
                  <span>About</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="#courses" className="nav-link">
                  <i className="fas fa-book"></i>
                  <span>Our Classes</span>
                </a>
              </li>
              {/* <li className="nav-item">
                <a href="#gallery" className="nav-link">
                  <i className="fas fa-camera"></i>
                  <span>Gallery</span>
                </a>
              </li> */}
              <li className="nav-item">
                <a href="#teachers" className="nav-link">
                  <i className="fas fa-users"></i>
                  <span>Teachers</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="#contact" className="nav-link">
                  <i className="fas fa-envelope"></i>
                  <span>Contact</span>
                </a>
              </li>
            </ul>
            {/* <a href="#enroll" className="enroll-btn">
              Enroll Now
            </a> */}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
